import { render } from "./TheErrorPage.vue?vue&type=template&id=1d0bde22&scoped=true"
import script from "./TheErrorPage.vue?vue&type=script&lang=js"
export * from "./TheErrorPage.vue?vue&type=script&lang=js"

import "./TheErrorPage.vue?vue&type=style&index=0&id=1d0bde22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0bde22"]])

export default __exports__